import React from "react";

import OptionField from "./option-field";
import TextField from "./text-field";

import CustomToast from "../../custom-toast";

//Pregunta de selección multiple
//El listado se compone de las alternativas correspondientes a los valores de "options" y la alternativa "Otro", al final de la pregunta, que aparece si se especifica en el json
const OptionsSurveyInput = ({
  dimensionIndex,
  questionIndex,
  selection = "single",
  handleChange,
  options,
  maximumCheckedOptions,
  optionsType = "default",
  defaultAnswer,
  other,
  additionalInputs,
}) => {
  const { answer, additionalAnswers } = defaultAnswer ?? {};

  const handleOptionChange = (event) => {
    if (!answer || selection === "single") {
      handleChange(event);
      return;
    }

    const numberOfSelectedOptions = answer.reduce((acc, option) => {
      if (option["value"] === true) {
        return acc + 1;
      }
      return acc;
    }, 0);

    if (numberOfSelectedOptions >= maximumCheckedOptions && event.target.checked) {
      CustomToast.error({
        messageTitle: "Atención!",
        Body: (
          <h6 className="text-justify">
            Esta pregunta solo permite marcar hasta {maximumCheckedOptions} alternativas. Revisa tus
            selecciones si deseas modificar una de ellas.
          </h6>
        ),
        showDismissButton: true,
      });
      event.preventDefault();
    } else {
      handleChange(event);
    }
  };

  const isCheckedOption = (option, optionIndex) => {
    if (!answer) {
      return false;
    }

    if (selection === "single") {
      switch (optionsType) {
        case "images":
          if (answer === option["label"]) {
            return true;
          }
          break;
        case "default":
        default:
          if (answer === option) {
            return true;
          }
          break;
      }
    } else if (selection === "multiple") {
      if (answer[optionIndex] && answer[optionIndex]["value"]) {
        return true;
      }
    }
    return false;
  };

  const bodyClassName = `${
    optionsType && optionsType === "images" ? "flex-row justify-content-center" : "flex-column"
  }`;

  return (
    <>
      <div className={`d-flex ${bodyClassName}`}>
        {options.map((option, optionIndex) => {
          const inputData =
            additionalInputs && additionalInputs.find((input) => input["relatedOption"] === option);
          const hasAdditionalInput = inputData ? true : false;

          return (
            <div
              key={`survey-question-field-options-${dimensionIndex}_${questionIndex}_option-${optionIndex}`}
            >
              <OptionField
                dimensionIndex={dimensionIndex}
                questionIndex={questionIndex}
                optionsType={optionsType}
                optionIndex={optionIndex}
                optionValue={option}
                handleChange={handleOptionChange}
                isChecked={isCheckedOption(option, optionIndex)}
                selection={selection}
              />
              {isCheckedOption(option, optionIndex) && hasAdditionalInput && (
                <TextField
                  fieldId={`survey-question-field-options-${dimensionIndex}_${questionIndex}_option-${optionIndex}_additional_input_${option}`}
                  label={inputData["label"]}
                  defaultAnswer={additionalAnswers[option]}
                  relatedOption={option}
                  handleChange={handleChange}
                />
              )}
            </div>
          );
        })}
        {other && (
          <OptionField
            dimensionIndex={dimensionIndex}
            questionIndex={questionIndex}
            optionIndex={options.length}
            optionValue="Otro"
            handleChange={handleOptionChange}
            isChecked={isCheckedOption("Otro", options.length)}
            selection={selection}
          />
        )}
        {isCheckedOption("Otro", options.length) && (
          <TextField
            fieldId={`${dimensionIndex}_${questionIndex}_${options.length}_additional_input_otro`}
            defaultAnswer={additionalAnswers["Otro"]}
            relatedOption={"Otro"}
            handleChange={handleChange}
          />
        )}
      </div>
    </>
  );
};

export default OptionsSurveyInput;
